export enum PrepopulateType {
  None = 0,
  All = 1,
  MFU_Frequency = 2,
  MRU = 3,
  MFU_Alpha = 4,
}
